import { useState } from 'react';

import companyLogo from '../assets/images/logo.png';
import phoneIcon from '../assets/images/icon1.png';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleMobileNavigation = (targetId) => {
    setToggleMenu(false);
    
    // For mobile, we want to scroll directly to the consultation form
    if (window.innerWidth < 768) {
      // On mobile, scroll directly to the consultation form
      const consultationForm = document.getElementById('consultation-form');
      if (consultationForm) {
        consultationForm.scrollIntoView({ 
          behavior: 'smooth',
          block: 'center' // Center the form in the viewport
        });
        // Trigger the form glow effect after scrolling
        setTimeout(() => {
          if (window.handleFormGlow) {
            window.handleFormGlow();
          }
        }, 1000);
      }
    } else {
      // On desktop, use normal navigation
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className='relative w-full'>
      {/* Mobile Phone Bar - Always visible on mobile */}
      <div className='md:hidden bg-white w-full py-3 px-4 flex items-center justify-center border-b border-gray-200 cursor-pointer' onClick={() => handleMobileNavigation('consultation-form')}>
        <div className='flex items-center space-x-2'>
          <img src={phoneIcon} alt='Phone' className='h-5 w-5' />
          <span className='text-black font-medium'>(305) 610-1001</span>
        </div>
      </div>

      {/* Main Navbar */}
      <div className='container mx-auto p-4 md:p-6 max-w-[1250px]'>
        {/* Flex Container */}
        <div className='flex items-center justify-between gap-2'>
          {/* Logo */}
          <div className='pt-1 cursor-pointer' onClick={() => handleMobileNavigation('consultation-form')}>
            <img src={companyLogo} alt='Company Logo' className='h-8 md:h-10' />
          </div>
          
          {/* Menu Items - Desktop Only */}
          <div className='hidden md:flex flex-1 justify-center font-semibold space-x-4'>
            <button onClick={() => handleMobileNavigation('features')} className='hover:text-[#00a1f1] transition-colors'>Our Process</button>
            <button onClick={() => handleMobileNavigation('solutions')} className='hover:text-[#00a1f1] transition-colors'>Solutions</button>
            <button onClick={() => handleMobileNavigation('industries')} className='hover:text-[#00a1f1] transition-colors'>Industries</button>
            <button onClick={() => handleMobileNavigation('team')} className='hover:text-[#00a1f1] transition-colors'>About Us</button>
            <button onClick={() => handleMobileNavigation('reviews')} className='hover:text-[#00a1f1] transition-colors'>Reviews</button>
          </div>
          
          {/* Phone Icon and Number - Desktop Only */}
          <div className='hidden md:flex items-center space-x-2 py-2 px-4 border rounded-3xl border-[#00a1f1]'>
            <img src={phoneIcon} alt='Phone' className='h-5 w-5' />
            <span className='text-black'>(305) 610-1001</span>
          </div>
          
          {/* Hamburger Icon - Mobile Only */}
          <button
            className={
              toggleMenu
                ? 'open block hamburger md:hidden focus:outline-none p-2'
                : 'block hamburger md:hidden focus:outline-none p-2'
            }
            onClick={() => setToggleMenu(!toggleMenu)}
            aria-label="Toggle menu"
          >
            <span className='hamburger-top'></span>
            <span className='hamburger-middle'></span>
            <span className='hamburger-bottom'></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className='md:hidden'>
        <div
          className={
            toggleMenu
              ? 'absolute flex flex-col items-center py-6 mt-2 space-y-4 font-semibold bg-white w-full left-0 right-0 shadow-lg border-t border-gray-100 z-50'
              : 'absolute flex-col items-center hidden py-6 mt-2 space-y-4 font-semibold bg-white w-full left-0 right-0 shadow-lg border-t border-gray-100 z-50'
          }
        >
          <button onClick={() => handleMobileNavigation('features')} className='text-gray-700 hover:text-[#00a1f1] transition-colors'>Our Process</button>
          <button onClick={() => handleMobileNavigation('solutions')} className='text-gray-700 hover:text-[#00a1f1] transition-colors'>Solutions</button>
          <button onClick={() => handleMobileNavigation('industries')} className='text-gray-700 hover:text-[#00a1f1] transition-colors'>Industries</button>
          <button onClick={() => handleMobileNavigation('team')} className='text-gray-700 hover:text-[#00a1f1] transition-colors'>About Us</button>
          <button onClick={() => handleMobileNavigation('reviews')} className='text-gray-700 hover:text-[#00a1f1] transition-colors'>Reviews</button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
